module.exports = __webpack_public_path__ + "img/column-width.8a9337a6.svg";